const helper = {
	getURL: getURL
};
export default helper;

/*
 * key: val となる条件を選択するときの遷移先URLを作る関数
 * ex. key = depAirport, val = NRT → 「成田発」に設定する遷移先URLを作る
 */
function getURL(params, key, val, appBase) {
	var buf = [];

	/* special */
	if (params.special && key !== "special") {
		buf.push(params.special);
	} else if (key === "special" && val) {
		buf.push(val);
		key = null;
	}

	/* depAirport */
	if (params.depAirport && key !== "depAirport") {
		buf.push(params.depAirport);
	} else if (key === "depAirport" && val) {
		buf.push(val);
		key = null;
	} else {
		buf.push("ALL");
	}

	/* dest0 */
	if (params.dest0 && key !== "dest0") {
		buf.push(params.dest0);
	} else if (key === "dest0" && val) {
		buf.push(val);
		key = null;
	}

	var path = buf.join("/") + "/";

	// page は params に指定されていてもデフォルトでは含めない
	if (key === "page" && val) {
		path += val + ".html";
		key = null;
	}

	buf = [];
	for (var id in params) {
		switch (id) {
			case "special":
			case "depAirport":
			case "dest0":
			case "page":
			case "jal_line":
				break;
			default:
				if (key !== id && params[id]) {
					buf.push(id + "=" + encodeURIComponent(params[id]));
				}
				break;
		}
	}
	if (key && val) {
		buf.push(key + "=" + val);
	}
	var query = buf.join("&");

	return appBase + path + (query ? "?" + query : "");
}



// WEBPACK FOOTER //
// ./web/WEB-INF/js/client/landing/view-helper.js